import { render, staticRenderFns } from "./CardAcceptanceSettings.vue?vue&type=template&id=559629de&scoped=true&"
import script from "./CardAcceptanceSettings.vue?vue&type=script&lang=ts&"
export * from "./CardAcceptanceSettings.vue?vue&type=script&lang=ts&"
import style0 from "./CardAcceptanceSettings.vue?vue&type=style&index=0&id=559629de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559629de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCard,VCardText,VCardTitle,VContainer,VSwitch})
